import { CheckIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { ButtonProps } from './Button';
import LoadingIcon from './loadingIcon';

type FeedbackIconLayerProps = {
  className?: string;
  loading?: ButtonProps['loading'];
};

const FeedbackIconLayer: React.FC<FeedbackIconLayerProps> = ({ className, loading }) => {
  return (
    <span
      className={classNames(className, 'absolute left-0 top-0 grid h-full w-full items-center justify-center bg-white')}
    >
      {loading ? <LoadingIcon className="fill-gray-700" /> : <CheckIcon data-testid="check-icon" className="w-5" />}
    </span>
  );
};

export default FeedbackIconLayer;
